export default __webpack_public_path__ + "static/media/LV.4ddf97ab.svg";